import React from 'react'
import { Outlet } from "react-router-dom";
import Topbar from './Topbar';
import AuthSidebar from './AuthSidebar';
import classes from './Layout.module.css'
const AuthLayout = () => {
    return (
        <div className={classes["parentLayout"]}>
            <Topbar />
            <AuthSidebar>
                <Outlet />
            </AuthSidebar>
        </div>
    )
}

export default AuthLayout